// this file is automatically generated by git.revision.js script
export const versions = { revision: 'de246dbc5d' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = 'de246dbc5d';
